export const plans = [
  {
    title: "Hot Discount Days",
    desc: "Every Seasonable Flowers",
    author: "Eleanor Vance",
    date: "At the End of April",
    location: "Daegu and Busan",
    img: "/img/discout_event.jpg",
  },
  {
    title: "Coming Soon",
    desc: "Be ready for fresh Arrivals from Monday!",
    author: "Eleanor Vance",
    date: "On May",
    location: "Daegu, Our Shop",
    img: "/img/premium-Home_header_bg.webp",
  },
  {
    title: "Floral Workshop",
    desc: "Join our master florists for a morning of crafting with rare dried blooms and seasonal foliage.",
    author: "Eleanor Vance",
    date: "2026.05.01",
    location: "Daegu, EXCO center - West Wind",
    img: "/img/workshopIMG.webp",
  },
  {
    title: "Join us on sns",
    desc: "🥬 We are deliver by Heart",
    author: "Eleanor Vance",
    date: "From Now",
    location: "Daegu, Bug-ku area",
    img: "/img/joinUS_subscription.webp",
  },
];
